import { forwardRef, HTMLAttributes, useContext } from 'react';

import FieldsetContext from '../context';

import s from './FieldsetHelp.module.scss';

export interface FieldsetHelpProps extends HTMLAttributes<HTMLParagraphElement> {
  children: string;
}

const FieldsetHelp = forwardRef<HTMLParagraphElement, FieldsetHelpProps>((props, ref) => {
  const FieldsetHelpContext = useContext(FieldsetContext);

  if (FieldsetHelpContext?.isInvalid) return null;

  return <p className={s.text} {...props} ref={ref} />;
});

export default FieldsetHelp;
